import { languages } from "@/i18n/settings";

export const VALID_LANGUAGES = languages;
